/**
 * @file Empty 空状态
 * @description 列表/面板无数据占位。
 *
 * @whenToUse 表格无行、搜索无结果。
 * @whenNotToUse 加载中（用 Spinner / Skeleton）；错误/完成页（用 Result）。
 */

import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'
import { cn } from '@/lib/cn.ts'

export type EmptyProps = {
  /** 主文案 */
  title?: ReactNode
  /** 次要说明 */
  description?: ReactNode
  /** 自定义图标 */
  icon?: ReactNode
  /** 底部操作（如 Button） */
  action?: ReactNode
  className?: string
}

export function Empty({
  title = '暂无数据',
  description,
  icon,
  action,
  className,
}: EmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-10 text-center',
        className,
      )}
    >
      <div className="text-muted">
        {icon ?? <Inbox className="size-10" aria-hidden />}
      </div>
      <div className="space-y-1">
        <div className="text-sm font-medium text-foreground">{title}</div>
        {description ? (
          <p className="text-xs text-muted">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  )
}
